<template>
  <!-- ===================== PERKS AND BENEFITS SECTION===================== -->
  <section
    class="mx-auto max-w-[1200px] px-[25px] mt-[125px] lg:h-[500px] xl:px-0"
  >
    <div class="mt-12 py-0">
      <h4
        id="text_member_activity"
        class="text-xs font-extrabold text-[#2D8CFF]"
      >
        PERKS AND BENEFITS
      </h4>

      <h2
        class="top-full mt-[20px] px-0 text-[35px] font-bold text-[#292d34] sm:text-[40px] lg:text-[45px] lg:leading-[69px] xl:text-[50px]"
      >
        Platforma Perks and Benefits.
      </h2>
    </div>

    <div class="mt-[45px] w-full flex-wrap justify-between md:flex">
      <div class="flex md:w-[50%]">
        <div class="w-[50%]">
          <img
            :src="$filters.media_path('/images/perks-macbook-blue.svg')"
            alt=""
            class="rounded-[20px] shadow-xl"
          />
          <h4 class="mt-[15px] flex text-lg font-medium text-[#292d34]">
            16" MacBook Pro.
          </h4>
        </div>
        <div class="w-[50%]">
          <img
            :src="$filters.media_path('/images/perks-utensils-yellow.svg')"
            alt=""
            class="rounded-[20px] shadow-xl"
          />
          <h4 class="mt-[15px] flex w-[75%] text-lg font-medium text-[#292d34]">
            Team lunches each week.
          </h4>
        </div>
      </div>

      <div class="mt-10 flex md:mt-0 md:w-[50%]">
        <div class="w-[50%]">
          <img
            :src="$filters.media_path('/images/perks-teal2-umbrella.svg')"
            alt=""
            class="rounded-[20px] shadow-xl"
          />
          <h4 class="mt-[15px] flex text-lg font-medium text-[#292d34]">
            Flexible PTO
          </h4>
        </div>
        <div class="w-[50%]">
          <img
            :src="$filters.media_path('/images/perks-truck-red.svg')"
            alt=""
            class="rounded-[20px] shadow-xl"
          />
          <h4 class="mt-[15px] flex text-lg font-medium text-[#292d34]">
            Moving Expenses
          </h4>
        </div>
      </div>
    </div>

    <div class="mt-[45px] w-full flex-wrap justify-between md:flex">
      <div class="flex md:w-[50%]">
        <div class="w-[50%]">
          <img
            :src="$filters.media_path('/images/perks-drinks-green.svg')"
            alt=""
            class="rounded-[20px] shadow-xl"
          />
          <h4 class="mt-[15px] flex w-[75%] text-lg font-medium text-[#292d34]">
            Unlimited snacks, kombucha, and cold brew.
          </h4>
        </div>
        <div class="w-[50%]">
          <img
            :src="$filters.media_path('/images/perks-swag-teal.svg')"
            alt=""
            class="rounded-[20px] shadow-xl"
          />
          <h4 class="mt-[15px] flex text-lg font-medium text-[#292d34]">
            Platforma Swag
          </h4>
        </div>
      </div>

      <div class="mt-10 flex md:mt-0 md:w-[50%]">
        <div class="w-[50%]">
          <img
            :src="$filters.media_path('/images/perks-bus-pink.svg')"
            alt=""
            class="rounded-[20px] shadow-xl"
          />
          <h4 class="mt-[15px] flex w-[75%] text-lg font-medium text-[#292d34]">
            $200/mo commuter benefits
          </h4>
        </div>
        <div class="w-[50%]">
          <img
            :src="$filters.media_path('/images/perks-present-purple.svg')"
            alt=""
            class="rounded-[20px] shadow-xl"
          />
          <h4 class="mt-[15px] flex w-[75%] text-lg font-medium text-[#292d34]">
            Teammate recognition rewards.
          </h4>
        </div>
      </div>
    </div>
  </section>
</template>

<script></script>

<style scoped></style>
